import * as React from "react";
import { forwardRef } from "react";
const SvgInterventionCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.583 16a1.59 1.59 0 0 1-1.249-.593L1.318 10.35a1.5 1.5 0 0 1-.267-.524 1.42 1.42 0 0 1 .164-1.132 1.595 1.595 0 0 1 .956-.69 1.64 1.64 0 0 1 1.19.156c.177.1.332.232.456.389l2.642 3.326 6.643-10.171c.22-.336.572-.575.976-.664.405-.09.83-.022 1.183.187.734.435.96 1.356.502 2.057l-7.85 12.012a1.5 1.5 0 0 1-.538.5c-.22.123-.466.192-.72.203z" }));
const ForwardRef = forwardRef(SvgInterventionCheck);
export { ForwardRef as ReactComponent };
